export function parseExtraArray1(raw) {
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function daysInStage(lead) {
  const extra = parseExtraArray1(lead?.extraArray1);
  const entered = extra.stageEnteredAt;
  const ts = Date.parse(entered || lead?.createdAt);
  if (Number.isNaN(ts)) return null;
  return Math.max(0, Math.floor((Date.now() - ts) / (1000 * 60 * 60 * 24)));
}

export function formatDaysInStage(days) {
  if (days == null) return "";
  if (days === 0) return "Today in stage";
  if (days === 1) return "1 day in stage";
  return `${days} days in stage`;
}
